namespace MACRAIL.Validation {

/**
 * Easy validation for form fields.
 */
export class LengthValidator implements IValidator {

    private opts: any;

    constructor (opts: any) {
        this.opts = opts;
    }

    public validate(value: any) {
        let opts = this.opts;
        let len = value.length;

        let messages: IValidatorMessage[] = [];

        if (opts.minLengthError && len < opts.minLengthError) {
            messages.push({
                'slug': 'length',
                'status': 'error',
                'message': `Must be at least ${opts.minLengthError} characters.`,
            });
        } else if (opts.minLengthWarning && len < opts.minLengthWarning) {
            messages.push({
                'slug': 'length',
                'status': 'warning',
                'message': `Should be at least ${opts.minLengthWarning} characters.`,
            });
        }

        if (opts.maxLengthError && len > opts.maxLengthError) {
            messages.push({
                'slug': 'length',
                'status': 'error',
                'message': `Must be ${opts.maxLengthError} characters or fewer.`,
            });
        } else if (opts.maxLengthWarning && len < opts.maxLengthWarning) {
            messages.push({
                'slug': 'length',
                'status': 'warning',
                'message': `Should be ${opts.maxLengthWarning} characters or fewer.`,
            });
        }

        return messages;
    }
}

}
